module.exports = __webpack_public_path__ + "img/icon-news.fde3b021.svg";